import { createFileRoute } from "@tanstack/react-router";
import SuperLayoutTitle from "@/components/layout/super-layout/super-layout-title";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import MigrationManager from "@/components/settings/migration-manager";
import { Database, Shield, AlertTriangle } from "lucide-react";

export const Route = createFileRoute("/_super/super/settings")({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <>
      <SuperLayoutTitle
        title="Configuración del Sistema"
        subtitle="Administra la configuración global y migraciones"
      />
      <div className="space-y-6">
        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <Database className="h-5 w-5 text-primary" />
              <CardTitle>Sistema de Suscripciones</CardTitle>
            </div>
            <CardDescription>
              Gestión multi-tenant con integración de pagos
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid gap-2">
              <div className="flex items-center gap-2">
                <Shield className="h-4 w-4 text-green-600" />
                <span className="text-sm">Integración con Dodo Payments</span>
                <Badge variant="default">Activo</Badge>
              </div>
              <div className="flex items-center gap-2">
                <Shield className="h-4 w-4 text-blue-600" />
                <span className="text-sm">Trial de 30 días automático</span>
                <Badge variant="secondary">Configurado</Badge>
              </div>
              <div className="flex items-center gap-2">
                <Shield className="h-4 w-4 text-purple-600" />
                <span className="text-sm">Período de gracia habilitado</span>
                <Badge variant="secondary">Configurado</Badge>
              </div>
            </div>

            <div className="mt-4 rounded-lg border border-orange-200 bg-orange-50 dark:border-orange-900 dark:bg-orange-950/20 p-4">
              <div className="flex items-start gap-2">
                <AlertTriangle className="h-5 w-5 text-orange-600 mt-0.5" />
                <div className="space-y-2">
                  <p className="text-sm font-medium text-orange-900 dark:text-orange-100">
                    Advertencias Importantes
                  </p>
                  <ul className="text-sm text-orange-800 dark:text-orange-200 space-y-1 list-disc list-inside">
                    <li>
                      Las migraciones modificarán la estructura de la base de
                      datos
                    </li>
                    <li>
                      Realiza un backup antes de ejecutar migraciones en
                      producción
                    </li>
                    <li>Algunas migraciones pueden tardar varios minutos</li>
                    <li>No interrumpas el proceso de migración</li>
                  </ul>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Gestor de Migraciones</CardTitle>
            <CardDescription>
              Ejecuta migraciones de base de datos y configuración del sistema
            </CardDescription>
          </CardHeader>
          <CardContent>
            <MigrationManager />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Instrucciones</CardTitle>
            <CardDescription>Pasos para gestionar el sistema</CardDescription>
          </CardHeader>
          <CardContent>
            <ol className="list-decimal list-inside space-y-2 text-sm text-muted-foreground">
              <li>Verifica el estado actual del sistema</li>
              <li>Revisa las advertencias antes de proceder</li>
              <li>Ejecuta las migraciones necesarias en orden</li>
              <li>Verifica que las suscripciones estén sincronizadas</li>
              <li>Monitorea el sistema después de cambios importantes</li>
            </ol>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
